import { useReducer, useState } from 'react';
import { Activity } from '../types';

export const useFilters = (
  minRunningRange_init: number,
  maxRunningRange_init: number,
  minCyclingRange_init: number,
  maxCyclingRange_init: number
) => {
  const [displayRunning, toggleDisplayRunning] = useReducer(
    (value) => !value,
    true
  );
  const [displayCycling, toggleDisplayCycling] = useReducer(
    (value) => !value,
    true
  );
  const [displaySwimming, toggleDisplaySwimming] = useReducer(
    (value) => !value,
    true
  );
  const [displayVirtualRide, toggleDisplayVirtualRide] = useReducer(
    (value) => !value,
    true
  );

  const [range, setRange] = useState({
    minRunningRange: minRunningRange_init,
    maxRunningRange: maxRunningRange_init,
    minCyclingRange: minCyclingRange_init,
    maxCyclingRange: maxCyclingRange_init,
  });

  const sportIncludesFilter = (activity: Activity) =>
    [
      displayRunning && 'Run',
      displayCycling && 'Ride',
      displaySwimming && 'Swim',
      displayVirtualRide && 'VirtualRide',
    ].includes(activity.sport_type);

  const runDistanceFilter = (activity: Activity) =>
    activity.sport_type === 'Run'
      ? activity.distance / 1000 > range.minRunningRange &&
        activity.distance / 1000 < range.maxRunningRange
      : activity;

  const rideDistanceFilter = (activity: Activity) =>
    activity.sport_type === 'Ride'
      ? activity.distance / 1000 > range.minCyclingRange &&
        activity.distance / 1000 < range.maxCyclingRange
      : activity;

  const handleCyclingRangeChange = ({
    min,
    max,
  }: {
    min: number;
    max: number;
  }) => {
    setRange((range) => ({
      ...range,
      minCyclingRange: min,
      maxCyclingRange: max,
    }));
  };

  const handleRunningRangeChange = ({
    min,
    max,
  }: {
    min: number;
    max: number;
  }) => {
    setRange((range) => ({
      ...range,
      minRunningRange: min,
      maxRunningRange: max,
    }));
  };

  return {
    sportIncludesFilter,
    runDistanceFilter,
    rideDistanceFilter,
    handleRunningRangeChange,
    handleCyclingRangeChange,
    displayVirtualRide,
    toggleDisplayVirtualRide,
    displaySwimming,
    toggleDisplaySwimming,
    displayCycling,
    toggleDisplayCycling,
    displayRunning,
    toggleDisplayRunning,
  };
};
